import { cn } from "@/utils/classnames";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-gray-100 animate-pulse rounded-md", className)}
      {...props}
    />
  );
}
export { Skeleton };
